import { Rung } from "../interface";

export const NEW_RUNG: Rung = {
  comment: "",
  elements: [],
  input: false,
  out: false,
};
